import { PerformCardAction } from './druid/types/CardActionMiddleware';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function usePerformCardAction(): PerformCardAction {
  return useWebChatAPIContext().onCardAction;
}
